import { Component, OnInit, OnDestroy, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { environment } from '../../environments/environment';
import { ConductorComponent } from "./conductor/conductor.component";
import { BusComponent } from "./bus/bus.component";
import { ViajeComponent } from "./viaje/viaje.component";
import { BsModalService } from "ngx-bootstrap/modal";
import { ModalIniciarViajeComponent } from "./modal-iniciar-viaje/modal-iniciar-viaje.component";
import { NgClass, NgStyle, NgFor, DatePipe, NgIf } from "@angular/common";
import { ApiService } from "../services/api.service";
import { KpiDTO } from "../../dtos/kpi.dto";
import { ViajeDTO } from "../../dtos/viaje.dto";
import { MovilDTO } from "../../dtos/movil.dto";
import { ConductorDTO } from "../../dtos/conductor.dto";
import { InfiniteScrollDirective } from "ngx-infinite-scroll";
import { FormsModule } from "@angular/forms";
import { Subject, Subscription, debounceTime, distinctUntilChanged, skip } from "rxjs";
import { CambiarSucursalComponent } from "../modals/cambiar-sucursal/cambiar-sucursal.component";
import { SucursalService } from "../services/sucursal.service";
import { EventService } from "../services/event.service";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModalCrearViajeV2Component } from './modal-crear-viaje-v2/modal-crear-viaje-v2.component';
import { ViajeService } from '../services/viaje.service';
import { AutoRefreshService } from '../services/auto-refresh.service';
import moment from 'moment';
import { ModalCrearViajeComponent } from "./modal-crear-viaje/modal-crear-viaje.component";
import { ConfigMqttService } from "../services/configMqtt.service";
import { IMqttMessage } from "ngx-mqtt";
import { ToastrService } from "ngx-toastr";
import { ModalCambiarSucursalMovilComponent } from '../modals/modal-cambiar-sucursal-movil/modal-cambiar-sucursal-movil.component';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-despachador',
  standalone: true,
  imports: [
    ConductorComponent,
    BusComponent,
    ViajeComponent,
    NgClass,
    NgStyle,
    NgFor,
    NgIf,
    DatePipe,
    InfiniteScrollDirective,
    FormsModule,
    CambiarSucursalComponent,
    ModalIniciarViajeComponent,
    TooltipModule,
    ProgressbarModule,
    NgSelectModule
  ],
  templateUrl: './despachador.component.html',
  styleUrl: './despachador.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DespachadorComponent implements OnInit, OnDestroy {

  indicadores: boolean = true;
  modoEstandar: boolean = true;
  kpis: KpiDTO[] = [];
  viajes: ViajeDTO[] = [];
  horaActual: string = "Cargando";
  kpiSelected: KpiDTO = undefined;
  searchText: string = '';
  componenteSeleccionado: string | null = null;
  selectedBus: MovilDTO | null = null;
  selectedConductor: ConductorDTO | null = null;
  selectedViaje: ViajeDTO | null = null;
  private intervalReloj: any;
  private searchSubject = new Subject<string>();

  // Subscriptions
  private subscriptions: Subscription[] = [];
  private listadoSuscripcionesViajesMqtt: { [key: string]: Subscription } = {};

  // Sorting variables
  orderBy: string = 'fechahoraInicio';
  orderAsc: boolean = true;

  // Propiedad para mostrar los nombres de las sucursales seleccionadas
  sucursalesSelectedNombres: string = '';
  public sucursalesSelectedNombresLargos: string = '';

  // Infinite scroll variables
  private pageSize: number = 50;
  private page: number = 0;
  private hasNext: boolean = false;
  public desactivarInfiniteScroll: boolean = true;
  private isLoadingSort: boolean = false;
  private isAutoRefresh: boolean = false;
  private isLoadingMore: boolean = false;
  private cargarViajesSub: Subscription | null = null;

  // Servicios-Sentidos select properties
  serviciosSentidos: any[] = [];
  servicioSentidoSeleccionado: string[] = [];

  public intervaloProgressBar: any;
  public contador: number = 0;
  public recarga = 900000;
  recargas = [
    { label: 'Off', value: 0 },
    { label: '15 minutos', value: 900000 },
  ];

  constructor(
    private modalService: BsModalService,
    private apiService: ApiService,
    public sucursalService: SucursalService,
    private eventService: EventService,
    private viajeService: ViajeService,
    private autoRefreshService: AutoRefreshService,
    private configMqttService: ConfigMqttService,
    private toastr: ToastrService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.calcularTime();
    this.initSucursalesSeleccionadas();
    this.horaActual = moment().format("HH:mm:ss");
    this.intervalReloj = setInterval(() => { this.horaActual = moment().format("HH:mm:ss"); }, 1000);

    // Configure search debounce
    this.searchSubject.pipe(
      debounceTime(500), // Wait for 500ms after the last event
      distinctUntilChanged() // Only emit if value is different from previous
    ).subscribe(searchText => {
      this.searchText = searchText;
      this.cargarViajes(true); // Reset and load with search text
    });

    const viajeConfirmadoSub = this.eventService.subscribe('VIAJE_CONFIRMADO_EVENT', () => {
      console.log("Se recibe evento de viaje confirmado");
      this.cargarKPIs();
    });
    this.subscriptions.push(viajeConfirmadoSub);

    const viajeIniciadoSub = this.eventService.subscribe('VIAJE_INICIADO_EVENT', () => {
      console.log("Se recibe evento de viaje iniciado");
      this.cargarKPIs();
    });
    this.subscriptions.push(viajeIniciadoSub);

    // Recargar KPIs al asignar/quitar movil o conductor desde el detalle del viaje
    const asignacionViajeSub = this.eventService.subscribe('ASIGNACION_VIAJE_EVENT', () => {
      this.cargarKPIs();
    });
    this.subscriptions.push(asignacionViajeSub);

    const sucursalesSub = this.sucursalService.sucursales$.pipe(skip(1)).subscribe(() => {
      this.sucursalesSelectedNombres = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto();
      this.sucursalesSelectedNombresLargos = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto(true);
      this.initAllDatosWS();
    });
    this.subscriptions.push(sucursalesSub);

    const crearViajeSub = this.eventService.subscribe('CREAR_VIAJE_EVENT', () => {
      console.log("CREAR_VIAJE_EVENT en despachador");
      this.cargarKPIs();
      this.cargarViajes(true);
    });
    this.subscriptions.push(crearViajeSub);

    this.initAllDatosWS();
    this.cargarServiciosSentidos();
  }

  ngOnDestroy(): void {

    if (this.intervaloProgressBar) {
      clearInterval(this.intervaloProgressBar);
    }

    if (this.intervalReloj) {
      clearInterval(this.intervalReloj);
    }

    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.subscriptions = [];
    this.unsubscribeMqtt();
  }

  initAllDatosWS() {

    if (!this.sucursalService.getSucursalesSeleccionadas() || this.sucursalService.getSucursalesSeleccionadas().length == 0) {
      this.openModalCambiarSucursal();
      return;
    }

    this.cargarKPIs();
    this.cargarViajes(true);
  }


  reload() {
    this.calcularTime();
    this.cargarKPIs();
    this.cargarViajes(true);
  }

  calcularTime() {
    clearInterval(this.intervaloProgressBar);
    if (this.recarga != 0)
      this.initProgressBar();
  }

  initProgressBar() {
    this.contador = this.recarga;
    this.intervaloProgressBar = setInterval(() => {
      this.contador -= 1000;
      if (this.contador < 0) {
        this.isAutoRefresh = true;
        this.cargarKPIs();
        this.cargarViajes(true);

        // Notificar a los componentes hijo que deben actualizar sus datos
        this.autoRefreshService.emitRefresh();

        this.contador = this.recarga;
      }
    }, 1000);
  }

  // Método para inicializar las sucursales seleccionadas
  initSucursalesSeleccionadas(): void {
    this.sucursalesSelectedNombres = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto();
    this.sucursalesSelectedNombresLargos = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto(true);
  }

  // Método para abrir el modal de cambio de sucursal
  openModalCambiarSucursal(): void {
    this.modalService.show(CambiarSucursalComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-md'
    });
  }

  cargarKPIs(): void {
    const terminalesUuids = this.sucursalService.getSucursalesUUIDSeleccionadasComoTexto();

    // Usar getKPISporSeccion en lugar de getKPISDespachador para incluir el filtrado por terminal
    this.apiService.getKPISporSeccion(terminalesUuids, 'DESPACHADOR').subscribe({
      next: (response) => {
        if (response.success) {
          this.kpis = response.data;
        }
      },
      error: (error) => {
        console.error('Error al cargar KPIs:', error);
        this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
      }
    });
  }

  cargarViajes(reset: boolean = false): void {
    // Causa #3: cancelar cualquier request en vuelo para que una respuesta vieja
    // no quede appendeada sobre una lista que ya se reseteo o sobre una pagina
    // mas nueva.
    if (this.cargarViajesSub) {
      this.cargarViajesSub.unsubscribe();
      this.cargarViajesSub = null;
      // Causa #6: si la cancelacion ocurre con un append en vuelo, liberar el flag
      // para que el scroll no quede bloqueado a la espera de un next/error que
      // nunca va a llegar.
      this.isLoadingMore = false;
    }

    // Causa #1: evitar requests paginados concurrentes que pidan la misma pagina.
    if (!reset && this.isLoadingMore) {
      return;
    }

    if (reset) {
      this.page = 0;
      if (!this.isLoadingSort && !this.isAutoRefresh) {
        this.viajes = [];
      }
    }

    // Causa #1: avanzar la pagina ANTES del request, usando una copia local,
    // para que dos llamadas casi-simultaneas no terminen pidiendo el mismo numero.
    const pageToFetch = this.page;
    // Causa #4: en auto-refresh recargar la misma cantidad de registros que el
    // usuario tenia visibles (redondeado al proximo multiplo de pageSize), asi
    // la lista no se recorta a 50 y el proximo scroll no se solapa con la nueva
    // pagina 0.
    const pageSizeToFetch = (reset && this.isAutoRefresh && this.viajes.length > this.pageSize)
      ? Math.ceil(this.viajes.length / this.pageSize) * this.pageSize
      : this.pageSize;
    this.page = pageToFetch + 1;

    if (!reset) {
      this.isLoadingMore = true;
    }
    // Causa #2: deshabilitar el infinite scroll mientras hay un request en vuelo,
    // para que el (scrolled) no siga emitiendo en bucle aunque alwaysCallback este
    // activo en alguna config.
    this.desactivarInfiniteScroll = true;

    const terminalesUuids = this.sucursalService.getSucursalesUUIDSeleccionadasComoTexto();

    const kpiCodigo = this.kpiSelected ? this.kpiSelected.codigo : '';

    // Join selected servicios-sentidos with comma separator
    const serviciosSentidos = this.servicioSentidoSeleccionado && this.servicioSentidoSeleccionado.length > 0
      ? this.servicioSentidoSeleccionado.join(',')
      : '';

    this.cargarViajesSub = this.apiService.getViajesDespachador(
      pageToFetch,
      pageSizeToFetch,
      this.searchText,
      kpiCodigo,
      terminalesUuids,
      this.orderBy,
      this.orderAsc,
      serviciosSentidos
    ).subscribe({
      next: (response) => {
        // El backend omite 'data' cuando no hay viajes; tratar como lista vacía para no romper.
        const lista = response.data?.list ?? [];
        if (reset) {
          this.viajes = lista;
        } else {
          this.viajes = [...this.viajes, ...lista];
        }

        this.hasNext = response.data?.hasNext ?? false;

        if (this.hasNext) {
          this.desactivarInfiniteScroll = false;
          // Causa #4: si esta llamada uso un pageSize mas grande (auto-refresh),
          // recalcular el indice de pagina equivalente para que el proximo scroll
          // no vuelva a pedir registros que ya estan en la lista.
          if (pageSizeToFetch !== this.pageSize) {
            this.page = pageToFetch + (pageSizeToFetch / this.pageSize);
          }
        } else {
          this.desactivarInfiniteScroll = true;
        }
        // Causa #5: dar de baja los topics MQTT cuya viaje ya no esta en la lista
        // (cambio de filtro/sort/sucursal/KPI/busqueda) para evitar callbacks vivos
        // que actualicen viajes obsoletos.
        this.limpiarSuscripcionesMqttObsoletas();
        this.initSuscripcionesMqtt();
        this.isLoadingSort = false;
        this.isAutoRefresh = false;
        this.isLoadingMore = false;
        this.cargarViajesSub = null;
      },
      error: (error) => {
        console.error('Error al cargar viajes:', error);
        this.desactivarInfiniteScroll = true;
        this.isLoadingSort = false;
        this.isAutoRefresh = false;
        this.isLoadingMore = false;
        this.cargarViajesSub = null;
        // Causa #1: si el request fallo, devolver page al valor previo para no
        // saltarse una pagina en el proximo intento.
        this.page = pageToFetch;
        this.toastr.error((error?.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
      }
    });
  }

  onScroll(): void {
    console.log('onScroll called, current page:', this.page);
    // Causa #1 / #2: si ya hay un request en vuelo o no hay mas paginas, ignorar
    // el evento de scroll. Esto evita que (scrolled) dispare cargas repetidas.
    if (this.isLoadingMore || !this.hasNext) {
      return;
    }
    console.log('Loading more data, requesting page:', this.page);
    this.cargarViajes();
  }

  openViajeN() {
    this.modalService.show(ModalCrearViajeComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-md'
    });
  }

  crearViajeV2() {
    this.modalService.show(ModalCrearViajeV2Component, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xl'
    });
  }

  verDetalleViaje(viaje: ViajeDTO) {
    const viajeCompleto = { ...viaje };
    this.viajeService.setViajeSeleccionadoDespachador(viajeCompleto);
    this.componenteSeleccionado = 'viaje';
    this.selectedViaje = viajeCompleto;
  }

  verMoviles(viaje: ViajeDTO) {
    this.viajeService.setViajeSeleccionadoDespachador(viaje);
    this.componenteSeleccionado = 'bus'
    this.selectedViaje = { ...viaje };
  }

  verConductores(viaje: ViajeDTO) {
    this.viajeService.setViajeSeleccionadoDespachador(viaje);
    this.componenteSeleccionado = 'conductor'
    this.selectedViaje = { ...viaje };
  }

  verViaje(tipo: string, viaje?: ViajeDTO) {

    this.componenteSeleccionado = tipo;

    if (viaje) {
      this.selectedViaje = { ...viaje };
      if (tipo === 'viaje') {
        // Load detailed trip information from API
        this.getDetalleDeViajeDespachador(viaje);
      } else {
        // For bus or conductor views, use the data we already have
        this.selectedViaje = { ...viaje };
      }

      // If we're viewing a bus and the viaje has a movil, set it as the selected bus
      if (tipo === 'bus') {
        this.selectedBus = viaje.movil ? { ...viaje.movil } : null;
        this.selectedConductor = viaje.conductor ? { ...viaje.conductor } : null;
      }

      // If we're viewing a conductor and the viaje has a conductor, set it as the selected conductor
      if (tipo === 'conductor') {
        this.selectedBus = viaje.movil ? { ...viaje.movil } : null;
        this.selectedConductor = viaje.conductor ? { ...viaje.conductor } : null;
      }
    }

  }

  getDetalleDeViajeDespachador(viaje: ViajeDTO) {
    this.apiService.getDetalleViaje(viaje.uuid).subscribe({
      next: (response) => {
        if (response.success) {
          console.log('obteniendo datos');
          // Create a new reference with all properties from the original viaje
          // and override with the detailed data from the API
          this.selectedViaje = {
            ...viaje,
            uuid: response.data.uuid,
            viajeCodigo: response.data.viajeCodigo,
            fechahoraInicio: response.data.fechahoraInicio,
            fechahoraInicioModificado: response.data.fechahoraInicioModificado,
            fechahoraInicioOriginalPlanificado: response.data.fechahoraInicioOriginalPlanificado,
            fechahorasalida: response.data.fechahorasalida,
            estado: response.data.estado,
            confirmado: response.data.confirmado,
            sucursalOrigen: response.data.sucursalOrigen,
            sucursalDestino: response.data.sucursalDestino,
            servicio: response.data.servicio,
            sentido: response.data.sentido,
            contratoCodigo: response.data.contratoCodigo,
            tipoMovilRequerido: response.data.tipoMovilRequerido,
            viajeTipo: response.data.viajeTipo,
            conductor: response.data.conductor,
            movil: response.data.movil
          };
        } else {
          console.error('Error loading trip details:', response.msg);
          this.toastr.warning(response.msg, 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
        }
      },
      error: (error) => {
        console.error('Error loading trip details:', error);
        this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
      }
    });
  }

  onKpiClick(kpi: KpiDTO): void {

    if (this.kpiSelected && this.kpiSelected.codigo == kpi.codigo)
      this.kpiSelected = undefined;
    else
      this.kpiSelected = kpi;
    // Reload data with the selected KPI while maintaining the current search text
    // Reset pagination (page=0) and clear viajes array
    this.cargarViajes(true);
  }

  onSearchChange(text: string): void {
    this.searchSubject.next(text);
  }

  onSort(field: string): void {
    // If clicking on the same field, toggle the sort direction
    if (this.orderBy === field) {
      this.orderAsc = !this.orderAsc;
    } else {
      // If clicking on a different field, set it as the new sort field and default to ascending
      this.orderBy = field;
      this.orderAsc = true;
    }
    // Set loading flag to keep current data visible while sorting
    this.isLoadingSort = true;
    // Reset and reload data with the new sort parameters
    this.cargarViajes(true);
  }

  getCodigoSucursalSugerida(viaje : ViajeDTO){
    if(viaje.conductorSugerido && viaje.conductorSugerido.contratoSucursal){
      return '('+ viaje.conductorSugerido.contratoSucursal.codigo+')';
    }
    return '';
  }

  onViewChange(event: { type: string, viajeSeleccionado: ViajeDTO | null }): void {
    if (event.viajeSeleccionado) {
      // Switch to the requested view (bus or conductor)
      this.verViaje(event.type, event.viajeSeleccionado);
    }
  }

  getSentido(viaje: ViajeDTO){
    if(viaje.sentido){
      if(viaje.sentido == 'REGRESO'){
        return 'REG';
      }
      return viaje.sentido;
    }
    return '';
  }

  isViajeAtrasado(viaje: ViajeDTO): boolean {
    if (viaje.estado === 'EN_CURSO') {
      return false;
    }

    const now = new Date();
    const fechaInicio = new Date(viaje.fechahoraInicio);

    return now >= fechaInicio;
  }

  // CON-1004: no se puede iniciar un viaje sin confirmar, en curso, no iniciado o finalizado
  noSePuedeIniciar(viaje: ViajeDTO): boolean {
    return !viaje.confirmado
      || viaje.estado === 'EN_CURSO'
      || viaje.estado === 'NO_INICIADO'
      || viaje.estado === 'FINALIZADO';
  }

  tienePermisoIniciarViaje(): boolean {
    return this.userService.tienePermiso('VIAJE_INICIAR');
  }

  tienePermisoCambiarSucursalMovil(): boolean {
    return this.userService.tienePermiso('MOVIL_CAMBIAR_SUCURSAL');
  }

  tienePermisoCrearViaje(): boolean {
    return this.userService.tienePermiso('DESPACHADOR_VER_CREAR_VIAJE');
  }

  iniciarViaje(viaje: ViajeDTO): void {
    // CON-1004: bloquear inicio en estados no editables
    if (this.noSePuedeIniciar(viaje)) {
      return;
    }
    this.modalService.show(ModalIniciarViajeComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs',
      initialState: {
        viaje: viaje
      }
    });
  }

  cambiarSucursalMovil(){
    this.modalService.show(ModalCambiarSucursalMovilComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-xs'
    });
  }

  initSuscripcionesMqtt() {
    console.log('init suscripcion mqtt viajes');
    this.viajes.forEach((viaje) => {
      if (!this.listadoSuscripcionesViajesMqtt[viaje.uuid]) {
        this.listadoSuscripcionesViajesMqtt[viaje.uuid] = this.configMqttService.subscribeTopicViajes(viaje.uuid).subscribe((mqttMessage: IMqttMessage) => {
          const json = JSON.parse(mqttMessage.payload.toString());
          const indice = this.viajes.findIndex(viajeItem => (viajeItem.uuid === json.uuid) && (viajeItem.version < json.version));
          if (indice !== -1)
            this.getDetalleViajeActualizado(viaje.uuid);
        });
      }
    })
  }

  unsubscribeMqtt() {
    for (let uuid in this.listadoSuscripcionesViajesMqtt) {
      if (this.listadoSuscripcionesViajesMqtt[uuid])
        this.listadoSuscripcionesViajesMqtt[uuid].unsubscribe();
    }
  }

  // Causa #5: limpia las suscripciones MQTT de viajes que ya no estan en la lista
  // visible (por cambio de filtro, sort, sucursal, KPI o busqueda), asi callbacks
  // viejos no actualizan viajes que ya no corresponden al estado actual.
  private limpiarSuscripcionesMqttObsoletas() {
    const uuidsVigentes = new Set(this.viajes.map(v => v.uuid));
    for (const uuid in this.listadoSuscripcionesViajesMqtt) {
      if (!uuidsVigentes.has(uuid)) {
        this.listadoSuscripcionesViajesMqtt[uuid]?.unsubscribe();
        delete this.listadoSuscripcionesViajesMqtt[uuid];
      }
    }
  }

  getDetalleViajeActualizado(uuid: string) {
    this.apiService.getDetalleViaje(uuid)
      .subscribe((resp) => this.getDetalleViajeActualizadoSuccess(resp));
  }

  getDetalleViajeActualizadoSuccess(response: any) {
    if (response.success && response.data) {
      const indice = this.viajes.findIndex(viaje => viaje.uuid === response.data.uuid);
      if (indice !== -1) {
        this.viajes[indice] = response.data;
        this.eventService.publish('VIAJE_ACTUALIZADO_MQTT_EVENT', this.viajes[indice])
      }
    }
  }

  cargarServiciosSentidos(): void {
    this.apiService.getServiciosSentidos().subscribe({
      next: (response) => {
        if (response.success) {
          this.serviciosSentidos = response.data.map((item: any) => ({
            value: `${item.serviceName}-${item.sentido}`,
            label: `${item.serviceName} - ${item.sentido}`
          }));
        }
      },
      error: (error) => {
        console.error('Error al cargar servicios-sentidos:', error);
        this.toastr.error((error?.error?.msg || 'Error al cargar servicios') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
      }
    });
  }

  onServicioSentidoChange(): void {
    this.cargarViajes(true);
  }

  getServiciosSentidosSeleccionados(): string {
    if (!this.servicioSentidoSeleccionado || this.servicioSentidoSeleccionado.length === 0) {
      return '';
    }

    if (this.servicioSentidoSeleccionado.length === 1) {
      const selected = this.serviciosSentidos.find(s => s.value === this.servicioSentidoSeleccionado[0]);
      return selected ? selected.label : '';
    }

    return `${this.servicioSentidoSeleccionado.length} seleccionados`;
  }
}
